import Image from "components/AppImage";
import React from "react";
import { useNavigate } from "react-router-dom";


export default function NoMarketScreen() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center bg-[#f8f8f8] font-[cairo] p-10">
      <div className="w-full max-w-sm  flex flex-col items-center text-center ">
        
        {/* الصورة */}
        <Image
          src="/assets/images/nomark.svg"
          alt="no restaurants"
          className="w-62 h-62 object-contain mb-4"
        />

        {/* العنوان */}
        <h2 className="text-[16px] font-bold text-gray-800 mb-2 font-[cairo]">
          لا يوجد ماركت قريب من هذا العنوان
        </h2>

        {/* الوصف */}
        <p className="text-[13px] text-gray-500 mb-4 leading-relaxed">
          قم بتغيير العنوان إلى عنوان آخر حتى تظهر النتائج القريبة منه
          بمسافة 2كم
        </p>

        {/* الزر */}
        <button
          onClick={() => navigate("/my-addresses")}
          className="bg-[#00B200] text-white px-6 py-2 rounded-[4px] text-sm font-medium "
        >
          تغيير العنوان
        </button>
      </div>
    </div>
  );
}